import { render, staticRenderFns } from "./NoDataSurveyLesson.vue?vue&type=template&id=2c07fefd&scoped=true&"
import script from "./NoDataSurveyLesson.vue?vue&type=script&lang=js&"
export * from "./NoDataSurveyLesson.vue?vue&type=script&lang=js&"
import style0 from "./NoDataSurveyLesson.vue?vue&type=style&index=0&id=2c07fefd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07fefd",
  null
  
)

export default component.exports